// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { GOOGLE_EVENTS } from "@guestsupply/XDL/constants";
import { parseProductCategories } from "@guestsupply/XDL/Utilities";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain as RemoveCartLineChain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";

export const _GaRemoveCartLine: typeof PopulateApiParameter = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const currentBillTo = getCurrentBillToState(state).value;
    const session = getSession(state);
    const locationId = session?.pickUpWarehouse?.id;

    if (state.xGoogleAnalytics.includeRemoveFromCartLineEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const cart = getCurrentCartState(props.getState()).value;
        const cartLine = cart?.cartLines?.find(c => c.id === props.apiParameter.cartLineId);

        if (!cartLine) {
            return;
        }

        dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

        const googleAnalyticsData = {
            event: GOOGLE_EVENTS.REMOVE_FROM_CART,
            ecommerce: {
                currency: state.context.session.currency?.currencyCode,
                value: cart?.orderGrandTotal,
                items: [
                    {
                        item_id: cartLine.erpNumber,
                        item_name: cartLine.shortDescription,
                        affiliation: currentBillTo?.companyName,
                        index: cartLine.line,
                        item_brand: cartLine.brand?.name,
                        location_id: locationId,
                        price: cartLine.pricing?.unitListPrice,
                        quantity: cartLine.qtyOrdered,
                        ...parseProductCategories(cartLine.properties?.categories),
                    },
                ],
                brand_code: currentBillTo?.properties?.brand,
                exclusive: currentBillTo?.properties?.exclusive,
                group_descr: currentBillTo?.properties?.groupDescription,
                customer_number: currentBillTo?.customerNumber,
            },
        };

        dataLayer.push(googleAnalyticsData);
    }
};

addToEndOfChain(RemoveCartLineChain, _GaRemoveCartLine);
